import styled from 'styled-components';
import { opoButtonStyles, opoCardStyles, opoTableStyles } from '../opo-styles';

export const SettingsTableCard = styled.div`
    ${opoCardStyles}

    margin-bottom: 20px;

    .table-card-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 8px 20px;
        border-bottom: 1px solid #EEF1F5;

        ${opoButtonStyles}

        .btn {
            height: 28px;
            padding: 0 12px;
        }
    }

    .table-card-header h4 {
        margin: 0;
        font-size: 15px;
        font-weight: 600;
        color: #1F2A37;
    }

    .table-card-header .count {
        font-size: 13px;
        color: #6B7A8F;
    }

    .table-card-header .btn {
        margin-left: auto;
    }

    .table-card-body {
        padding: 12px 12px 12px;
    }

    .table-card-body > .table > thead > tr > th:first-child {
        border-top-left-radius: 8px;
    }

    .table-card-body > .table > thead > tr > th:last-child {
        border-top-right-radius: 8px;
    }

    & > .table,
    .table-card-body > .table {
        margin-bottom: 0;
        ${opoTableStyles}
    }

    & > .table > tbody > tr > td[colspan],
    .table-card-body > .table > tbody > tr > td[colspan] {
        padding: 24px 16px !important;
        color: #6B7A8F;
        font-size: 14px !important;
    }

    & > .table > thead > tr > th:last-child,
    & > .table > tbody > tr > td:last-child,
    .table-card-body > .table > thead > tr > th:last-child,
    .table-card-body > .table > tbody > tr > td:last-child {
        text-align: right;
    }

    .muted {
        color: #6B7A8F;
    }
`;

const pillColors = {
    blue: { background: '#EEF3F9', color: '#16365A' },
    green: { background: '#E6F4EA', color: '#2E7D32' },
    gray: { background: '#F3F5F8', color: '#6B7A8F' },
    amber: { background: '#FFF1DE', color: '#9A4B00' }
};

export const Pill = styled.span<{ $color: keyof typeof pillColors }>`
    display: inline-block;
    padding: 2px 10px;
    border-radius: 999px;
    background-color: ${p => pillColors[p.$color].background};
    color: ${p => pillColors[p.$color].color};
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
`;
